/**
 * Steps JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Steps
 */
class PageSearch {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.theForm          = $( '#site-main-searchform' );
        this.filterToggle     = $( '#js-toggle-search-filters' );
        this.filterToggleIcon = this.theForm.find( '.toggle-search-filters__icon' );
        this.filters          = $( '#js-search-filters' );
        this.singleFiltersTab = this.theForm.find( '.js-single-tab' );
        this.allFields        = this.theForm.find( ':input' );
        this.searchSubmit     = $( '#js-submit-button' );
        this.searchSpinner    = $( '#js-searchform-spinner' );
        this.submitText       = $( '#js-searchform-submit-text' );
        this.submitIcon       = $( '#js-searchform-submit-icon' );

        // Post type filter buttons
        this.tabNavigation         = $( '#js-tab-nav' );
        this.postTypeFilterButtons = this.tabNavigation.find( '.js-tab-button' );
        this.postTypeFilterInput   = this.tabNavigation.find( '.js-posttype-filter' );
        this.postTypeNoFilters     = this.tabNavigation.find( '.js-no-filters' );

        // Buttons to control the datepickers
        this.buttonToday      = $( '#js-today-button' );
        this.buttonTomorrow   = $( '#js-tomorrow-button' );
        this.buttonOnWeekend  = $( '#js-weekend-button' );

        // Inputs for datepicker buttons
        this.buttonTodayInput     = $( '#js-today-button' ).find( 'input' );
        this.buttonTomorrowInput  = $( '#js-tomorrow-button' ).find( 'input' );
        this.buttonOnWeekendInput = $( '#js-weekend-button' ).find( 'input' );

        // Date pickers
        this.datePickers      = $( '#js-datepickers' );
        this.eventStart       = this.datePickers.find( '.js-datepicker-start' );
        this.eventEnd         = this.datePickers.find( '.js-datepicker-end' );
        this.allDatepickers   = this.datePickers.find( '.js-datepicker-input' );
        this.eventStartHidden = $( '#js-datepicker-start-hidden' );
        this.eventEndHidden   = $( '#js-datepicker-end-hidden' );

        // Accordions
        this.accordionButtons = this.theForm.find( '.js-accordion-button' );
        this.accordionIcons   = this.theForm.find( '.js-accordion-icon' );
        this.accordionContent = this.theForm.find( '.js-accordion-content' );

        // Fields
        this.checkBoxes   = this.accordionContent.find( 'input[type=checkbox]' );
        this.radioButtons = this.accordionContent.find( 'input[type=radio]' );
        this.textInputs   = this.accordionContent.find( 'input[type=text]' );

        // Single tabs
        this.tabs = this.theForm.find( '.js-single-tab' );

        // Tags for the tags dropdown
        this.tagInput           = this.tabs.find( '.js-tag-input' );
        this.tagField           = this.tagInput.find( '.js-taglist-search' );
        this.tagList            = this.tagInput.find( '.js-taglist' );
        this.tagFilters         = this.tagInput.find( '.js-single-tag' );
        this.selectedTags       = this.tagInput.find( '.js-selected-tags' );
        this.noTagsFound        = this.tagInput.find( '.js-no-tags-found' );
        this.selectedTagInputs  = this.tagInput.find( '.js-selected-tags-inputs' );
        this.tagStringForSearch = themeData.themeStrings.queries.tag;
        this.removeTagButton    = this.tagInput.find( '.js-remove-selected-tag' );

        // For screenreaders
        this.forScreenReaders          = $( '#js-filters-for-screenreaders' );
        this.forScreenReadersType      = $( '#js-filters-for-screenreaders-type' );
        this.forScreenReadersTags      = $( '#js-filters-for-screenreaders-tags' );
        this.forScreenReadersDate      = $( '#js-filters-for-screenreaders-date' );
        this.forScreenReadersStartDate = $( '#js-filters-for-screenreaders-startdate' );
        this.forScreenReadersEndDate   = $( '#js-filters-for-screenreaders-enddate' );
        this.filtersStringTitle        = $( '#js-search-filters-title-string' );

        // Strings for screenreaders
        this.searchForString     = themeData.themeStrings.search_for;
        this.searchForEverything = themeData.themeStrings.everything;
        this.searchForFiles      = themeData.themeStrings.files;
        this.filtersString       = themeData.themeStrings.filters;
        this.dateString          = themeData.themeStrings.date;
        this.startDateString     = themeData.themeStrings.start_date;
        this.endDateString       = themeData.themeStrings.end_date;
        this.todayDateString     = themeData.themeStrings.search.today;
        this.tomorrowDateString  = themeData.themeStrings.search.tomorrow;
        this.weekendDateString   = themeData.themeStrings.search.this_weekend;
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Set the steps wrap minus margin while resizing
        this.filterToggle.on( 'click', ( e ) => {
            this.filterToggleIcon.toggleClass( 'toggle-search-filters__icon--rotated' );
            this.filters.toggleClass( 'js-hidden' );

            // Get aria-expanded state.
            const expandedStatus = $( this.filterToggle ).attr( 'aria-expanded' );

            if ( expandedStatus == 'false' ) {
                $( this.filterToggle ).attr( 'aria-expanded', 'true' );
            } else {
                $( this.filterToggle ).attr( 'aria-expanded', 'false' );
            }

            // Make sure none of the filters are open.
            // NOTE: Uncomment if all selections wish to be cleared upon clicking
            // this.tabs.addClass( 'js-hidden' );
            // this.postTypeFilterInput.removeAttr( 'checked' );
            // this.closeAccordions();
            // this.fieldFormatter();
        });

        // Event search forms buttons to control the time window
        // Today -button - set the time window from today to today
        this.buttonToday.on( 'click', ( e ) => {
            this.eventStart.datepicker( 'setDate', 'today' );
            this.eventEnd.datepicker( 'setDate', 'today' );

            this.filtersForScreenreaders( this.forScreenReadersDate, this.todayDateString );
        });

         // Tomorrow -button - set the time window from tomorrow to tomorrow
         this.buttonTomorrow.on( 'click', ( e ) => {
            this.eventStart.datepicker( 'setDate', '+1' );
            this.eventEnd.datepicker( 'setDate', '+1' );

            this.filtersForScreenreaders( this.forScreenReadersDate, this.tomorrowDateString );
        });

        // On weekend -button - set the time window from next friday to sunday.
        this.buttonOnWeekend.on( 'click', ( e ) => {
            this.eventStart.datepicker( 'setDate', this.getNextDayOfWeek( '5' ) );
            this.eventEnd.datepicker( 'setDate', this.getNextDayOfWeek( '7' ) );

            this.filtersForScreenreaders( this.forScreenReadersDate, this.weekendDateString );
        });

        // Unset the value on date radio buttons when manually changing dates
        this.allDatepickers.on( 'change', ( e )=> {
            this.buttonTodayInput.removeAttr( 'checked' );
            this.buttonTomorrowInput.removeAttr( 'checked' );
            this.buttonOnWeekendInput.removeAttr( 'checked' );

            // Update the dates for screen readers
            if ( this.eventEnd.val() != '' ) {
                this.filtersForScreenreaders( this.forScreenReadersEndDate, this.eventEnd.val() );
            }

            if ( this.eventStart.val() != '' ) {
                this.filtersForScreenreaders( this.forScreenReadersStartDate, this.eventStart.val() );
            }

        });

        // Prevent the accordion button clicks to send the form
        this.accordionButtons.on( 'click', ( e ) => {
            Theme.Common.stop( e );
        });

        // Add checked checkboxes to be read with screenreaders
        this.checkBoxes.each( ( e, item ) => {
            $( item ).on( 'click', ( e ) => {

                // Get the item, its text and value
                const currentItem = $( e.currentTarget );
                const currentItemText = currentItem.parent( 'label' ).text() ;
                const currentItemValue = currentItem.attr( 'value' );

                // Call the function for screen readers
                this.filtersForScreenreaders( this.forScreenReadersTags, currentItemText, currentItemValue );

            });
        });

        // Because the labels on post type filters also function as tab controllers,
        // the checked attribute has to be placed here on the corresponding
        // input field. The labels have a href and the default action is prevented, hence
        // the input field is not normally checked.
        // Also, clear all other selected / filled fields and close the accordions
        this.postTypeFilterButtons.each( ( e, item ) => {
            $( item ).on( 'click', ( e ) => {

                Theme.Common.stop( e );

                // Get the clicked button
                const clickedItem = $( e.currentTarget );

                // Set the clicked post type filter as active
                clickedItem.siblings( 'input' ).attr( 'checked', true );

                // Empty all filled fields
                this.fieldFormatter();

                // Close all the accordions
                this.closeAccordions();

                // Control the screenreaders for this type
                // Get the text value for the current type
                const currentTypeText = clickedItem.text();

                this.filtersForScreenreaders( this.forScreenReadersType, currentTypeText );
            });
        });

        // If a post type with no filters is selected, clear all the filters
        this.postTypeNoFilters.on( 'click', ( e ) => {

            Theme.Common.stop( e );

            // Make sure none of the filters are open
            this.tabs.addClass( 'js-hidden' );

            // Empty all filled fields
            this.fieldFormatter();

            // Close all the accordions
            this.closeAccordions();

            // Check if the search is for files or for everything
            if ( $( e.currentTarget ).hasClass( 'js-file-search' ) ) {
                this.filtersForScreenreaders( this.forScreenReadersType, this.searchForFiles );
            } else {
                this.filtersForScreenreaders( this.forScreenReadersType, this.searchForEverything );
            }


        });

        // Filter tags on the taglist search
        this.tagField.on( 'input', ( e ) => {

            const currentSearch = e.target.value;

            // A function to control which tags to show
            this.controlTagFilters( currentSearch );
        });

        // Control a single tag button on a tag dropdown
        this.tagFilters.each( ( e, item ) => {

            // Bind a click event on all the tags
            $( item ).on( 'click', ( e ) => {
                Theme.Common.stop( e );

                // Empty the field
                this.tagField.val( '' );

                // Get the name and the value of the id -attribute of the selected tag
                const clickedItem       = $( e.currentTarget );
                const clickedItemsValue = clickedItem.attr( 'data-id' );
                const clickedItemsText  = clickedItem.text();

                // Close the tag list & remove the selected value from the list based on its id,
                // to make it extra sure what to remove
                this.addAndRemoveTags( clickedItemsValue, 'show' );

                // Add selected tag to a visual list of selected tags & to a hidden input field
                this.addTagsToSearch( clickedItemsValue, clickedItemsText );

                // Update the filters for screenreaders
                this.filtersForScreenreaders( this.forScreenReadersTags, clickedItemsText, clickedItemsValue );

                // focus back on the main field
                this.tagField.focus();

            });
        });

        // Bind a click event to each remove tag button to remove them, done by removeSelectedTag function.
        this.removeTagButton.each( ( e, item ) => {
           $( item ).on( 'click', ( e ) => {
                Theme.Common.stop( e );
                this.removeSelectedTag( e.currentTarget );
            });
        });

        // Make sure that no hidden fields are displayed in the url upon send.
        this.theForm.submit( ( e ) => {

            // Disable the submit button.
            this.searchSubmit.attr( 'disabled', 'disabled' );
            this.searchSubmit.addClass( 'spinner-active' );

            // Show spinner, hide other elements inside submit button.
            this.searchSpinner.removeClass( 'hidden' );
            this.submitText.addClass( 'hidden' );
            this.submitIcon.addClass( 'hidden' );


            this.allFields.each( ( e, item ) => {
                if ( $( item ).attr( 'type' ) == 'hidden' && $( item ).val() == '' ) {
                    $( item ).attr( 'disabled', true );
                }
            });
        });
    }

    /**
     * Create datepickers from input fields with jquery ui
     */
    createDatepickers() {

        // Get the language of the site
        const currentLang = document.documentElement.lang;

        this.eventStart.datepicker({
            altField: this.eventStartHidden,
            altFormat: 'yy-mm-dd',
            dateFormat: 'd.m.yy',
            regional: 'fi'
        });
        this.eventEnd.datepicker({
            altField: this.eventEndHidden,
            altFormat: 'yy-mm-dd',
            dateFormat: 'd.m.yy',
            regional: 'fi'
        });

        // Check the sites language and change the datepicker
        // language to match that
        if ( currentLang == 'en-GB' ) {
            $.datepicker.setDefaults( $.datepicker.regional['en-GB']);
        } else if ( currentLang == 'fi' ) {
            $.datepicker.setDefaults( $.datepicker.regional.fi );
        } else if ( currentLang == 'sv-SE' ) {
            $.datepicker.setDefaults( $.datepicker.regional.sv );
        }
    }

    /**
     * Get the date for a wanted weekday, the n:th weekday
     *
     * @param {number} dayOfWeek 1-7, the day wanted to find, 1 being monday
     */
    getNextDayOfWeek( dayOfWeek ) {

        // Create the new date and find out the next n:th date
        let wantedDate = new Date();
        wantedDate.setDate( wantedDate.getDate() + ( 7 + dayOfWeek - wantedDate.getDay() ) % 7 );

        return wantedDate;
    }

    /**
     * Empty all the values from fields
     */
    fieldFormatter() {

        // Empty checkboxes
        this.checkBoxes.removeAttr( 'checked' );

        // Empty radio buttons
        this.radioButtons.removeAttr( 'checked' );

        // Empty text input fields
        this.textInputs.val( '' );

        // Clear all the selected tag fields and visible tags. Visible tags are created dynamically,
        // that's why we can't cache them on page load.
        this.selectedTagInputs.html( '' );
        $( '.js-selected-tag' ).remove();
    }

    /**
     * This closes all the accordions and controls their arias
     */
    closeAccordions() {
        this.accordionButtons.attr( 'aria-expanded', 'false' );
        this.accordionIcons.removeClass( 'rotate-icon' );
        this.accordionContent.addClass( 'js-hidden' );
    }

    /**
     *
     * Filter tags based on the current search
     *
     * @param {string} currentSearch The current search
     */
    controlTagFilters( currentSearch ) {

        // Check if current search is not empty
        if ( currentSearch != '' ) {

            // Show taglist
            this.tagList.removeClass( 'js-hidden' );

            // Go through each tag
            this.tagFilters.each( ( e, item ) => {

                // Get the text of the current tag looped in each
                const currentTag = $( item ).text();

                // If the tag includes the current search, show it. If not, hide it.
                if ( ! currentTag.includes( currentSearch  ) ) {
                    $( item ).addClass( 'js-hidden' );
                    $( item ).removeClass( 'js-visible-item' );
                } else {
                    $( item ).removeClass( 'js-hidden' );
                    $( item ).addClass( 'js-visible-item' );
                }

            });
        } else {

            // Hide taglist
            this.tagList.addClass( 'js-hidden' );
        }

        // Inform user if no tags are found. Check the length of the visible item class in tag list ul
        // to get the correct amount of vibisible items
        if ( this.tagList.find( 'ul' ).find( '.js-visible-item' ).length == 0 ) {
            this.noTagsFound.removeClass( 'js-hidden' );
        } else {
            this.noTagsFound.addClass( 'js-hidden' );
        }
    }

    /**
     * Add the clicked tag to a hidden form field & to the selected tags list.
     *
     * @param {int} clickedItemsValue Id of the current tag.
     * @param {*} clickedItemsText  Text of the clicked tag.
     */
    addTagsToSearch( clickedItemsValue, clickedItemsText ) {

        // Append the tag
        this.selectedTags.append( '<div class="filters-dropdown__selected-tags__single  js-selected-tag">' + clickedItemsText + '<button class="filters-dropdown__selected-tags__single__remove-button js-id-' + clickedItemsValue + ' js-remove-selected-tag" data-id="' + clickedItemsValue + '"><i class="far fa-times filters-dropdown__selected-tags__single__remove-button__icon"></i></button></div>' );

        this.selectedTagInputs.append( ' <input type="hidden" name="' + this.tagStringForSearch + '[]" value="' + clickedItemsValue + '">' );

        // Create a click event to the remove -button.
        // Run a function to delete the tag.
        // Can't cache these, as they are dynamically added, also make sure to bind it once,
        // and to the button just created.
        this.selectedTags.find( '.js-id-' + clickedItemsValue ).on( 'click', ( e ) => {
            Theme.Common.stop( e );
            this.removeSelectedTag( e.currentTarget );
        });
    }

    /**
     *
     * Show or hide tags from the tag list
     *
     * @param {string} selectedTag The selected tag to be removed from the tag list.
     */
    addAndRemoveTags( selectedTag, showOrHide ) {

        // Hide the tag list
        this.tagList.addClass( 'js-hidden' );

        // Go through all the filters to hide or show the selected one
        this.tagFilters.each( ( e, item ) => {

            // Get the data-id value of the looped tag
            const currentValue = $( item ).attr( 'data-id' );

            // If the selected tag matches the looped tag, hide or show it
            if ( selectedTag == currentValue ) {

                if ( showOrHide == 'hide' ) {
                    $( item ).parent( 'li' ).removeClass( 'js-hidden' );
                } else {
                    $( item ).parent( 'li' ).addClass( 'js-hidden' );
                }

                // Stop the each loop, no need to continue it further once we find what we need.
                return false;
            }
        });

        // Remove the tag from the hidden fields - loop through the hidden input fields
        // to find the right one to remove
        this.selectedTagInputs.children().each( ( e, item ) => {
            const currentInputsValue = $( item ).val();

            if ( selectedTag == currentInputsValue ) {
                $( item ).remove();
            }
        });
    }

    /**
     * Open the tab and accordions of the current search
     */
    showCurrentSearch() {

        // Make sure all the tabs are hidden on load, and show only the one which was selected
        this.singleFiltersTab.addClass( 'js-hidden' );

        // Go through the post type filters and see if any is selected.
        // That's how we know if the search is done
        this.postTypeFilterInput.each( ( e, item ) => {

            // Loop through items until the checked one is found
            if ( $( item ).attr( 'checked' ) ) {

                // Show the filter list if a checked one is found
                this.filters.removeClass( 'js-hidden' );

                // Get the current tag to control
                const tabToOpen = $( item ).siblings( '.js-tab-button' ).attr( 'href' );
                $( tabToOpen ).removeClass( 'js-hidden' );

                // Rotate the icon to match the status of the tabs list
                this.filterToggleIcon.toggleClass( 'toggle-search-filters__icon--rotated' );

                // Open the accordions
                // - Check if there are any seleced tags. We know it it the selectedTags -container has any children
                if ( this.selectedTags.children().length > 0 ) {

                    // Search for the selected tags -sections parent accordion and open it
                    const accordionToBeOpened = this.selectedTags.parent( '.js-accordion-content' );
                    this.openAccordion( accordionToBeOpened );
                }

                // - Check the checkboxes
                this.checkBoxes.each( ( e, item ) => {
                    if ( $( item ).attr( 'checked' ) ) {
                        const accordionToBeOpened = $( item ).parents( '.js-accordion-content' );
                        this.openAccordion( accordionToBeOpened );
                    }
                });

                // Exit after the right one is found
                return false;
            }
        });

    }

    /**
     * Open an accordion element
     *
     * @param {string} accordion The accordion to be opened.
     */
    openAccordion( accordion ) {
        const accordionButton = accordion.siblings( '.js-accordion-heading' ).find( '.js-accordion-button' );

        accordion.removeClass( 'js-hidden' );
        accordionButton.attr( 'aria-expanded', 'true' );
        accordionButton.find( '.js-accordion-icon' ).addClass( 'rotate-icon' );
    }

    /**
     * Remove the clicked tag
     *
     * @param {object} clickedTag The clicked tag
     */
    removeSelectedTag( clickedTag ) {

            // The parent div of the tags remove -button, containing the tags name
            const currentTagParent = $( clickedTag ).parent( '.js-selected-tag' );

            // Get the value of the tag to be deleted
            const tagToBeRemovedId = $( clickedTag ).attr( 'data-id' );

            // Name of the tag to be removed, for screenreaders
            const tagToBeRemovedText = currentTagParent.text();

            this.filtersForScreenreaders( this.forScreenReadersTags, tagToBeRemovedText, tagToBeRemovedId );

            // Remove the tag
            this.addAndRemoveTags( tagToBeRemovedId, 'hide' );

            // Remove the selected tag visually
            currentTagParent.remove();
    }

    /**
     * Set and remove filters for screen readers to be read.
     *
     * @param {object} filterType The type of the current filter
     * @param {string} currentFilter Current filter to be set or removed for screenreaders;
     * @param {int} filterId ID of the current filter, to know if its to be removed or added
     */
    filtersForScreenreaders(  filterType, currentFilter, filterId ) {

        // Check if the filter is the post type
        if ( filterType == this.forScreenReadersType ) {
            this.forScreenReadersType.html( this.searchForString + ' ' + currentFilter  + '. ' );

            // Empty the tag search
            this.forScreenReadersTags.html( '' );
            this.forScreenReadersDate.html( '' );

        // Check if the filter is a tag
        } else if ( filterType == this.forScreenReadersTags ) {

            // Check if the filter already exixst. If yes, delete it, if not, add it.
            let filterCounter = 0;

            this.forScreenReadersTags.children().each( ( e, item ) => {
                const currentId = $( item ).attr( 'filter-id' );

                if ( currentId == filterId ) {
                    $( item ).remove();
                    filterCounter++;
                }
            });

            // If the filtercounter is still 0, it means that the current one was not found. Add it now.
            if ( filterCounter == 0 ) {
                this.forScreenReadersTags.append( '<span filter-id="' + filterId + '">' + currentFilter + ', </span>' );
            }

        // Check if the filter is a date
        } else if ( filterType == this.forScreenReadersDate ) {

            // Fill in the current date for screenreaders
            this.forScreenReadersDate.html( this.dateString + ' ' + currentFilter );
            this.forScreenReadersStartDate.html( '' );
            this.forScreenReadersEndDate.html( '' );

        // Check if the filter is a start date
        } else if ( filterType == this.forScreenReadersStartDate ) {
            this.forScreenReadersStartDate.html( this.startDateString + ': ' + currentFilter );
            this.forScreenReadersDate.html( '' );

        // Check if the filter is an end date
        } else if ( filterType == this.forScreenReadersEndDate ) {
            this.forScreenReadersEndDate.html( this.endDateString + ': ' + currentFilter );
            this.forScreenReadersDate.html( '' );
        }

        // If there are filters to be found, add the filters title to the start of the tag filters list
        // by removing the js-hidden class. If there are no filters, hide the title.
        if ( this.forScreenReadersTags.children().length > 0 ) {
            this.filtersStringTitle.removeClass( 'js-hidden' );
        } else {
            this.filtersStringTitle.addClass( 'js-hidden' );
        }

    }

    /**
     * Hide the tags title for screenreaders if there are no selected tags
     * on page load.
     */
    hideScreenreaderTitleForTags() {

        if ( this.forScreenReadersTags.children().length == 0 ) {
            this.filtersStringTitle.addClass( 'js-hidden' );
        }
    }

    /**
     * Un-disable disabled fields & hide taglist on load
     */
    initFiltersAndForm() {

        // Enable disabled fields
        this.allFields.each( ( e, item ) => {
            if ( $( item ).attr( 'type' ) == 'hidden' ) {
                $( item ).prop( 'disabled', false );
            }
        });

        // Hide taglist
        this.tagList.addClass( 'js-hidden' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.createDatepickers();
        this.initFiltersAndForm();
        this.showCurrentSearch();
        this.hideScreenreaderTitleForTags();
    }
}

// Export the class reference.
module.exports = PageSearch;



// WEBPACK FOOTER //
// ./assets/scripts/page-search.js